import { api } from '@/fsd/shared/api';

export const accountCabinetOnboardingStart = async () => {
  return await api.post(`/api/v1/account/cabinet/onboarding/start/`);
};
